module.exports = __webpack_public_path__ + "static/media/dg6.295693c8.jpg";